import { FC } from 'react';
import { useLocalStorage } from 'react-use';
import { Navigate } from 'react-router-dom';

export const ProtectedRoute: FC<{ children: JSX.Element }> = ({ children }) => {
  if (!localStorage.getItem('token')) {
    return <Navigate to={`/login`} replace />;
  }

  return children;
};
